<template>
  <div class="squadra-tavolo" :class="squadraClass">
    <div class="cyan haScelto white--text" v-if="isCardVariant && haScelto_">Ha scelto</div>
    <div class="cyan staScegliendo white--text" v-if="isCardVariant && staScegliendo_">
      Sta scegliendo
    </div>

    <crediti
      v-if="isCardVariant && isVincente && mostraVincente"
      :crediti="offerta"
      class="offerta offerta-vincente"
      variant="dark"
      glow
    ></crediti>
    <v-menu eager absolute :disabled="disableMenu">
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <div v-if="isLineVariant" class="content-line">
            <div class="line-avatar">
              <img :src="pic" v-if="pic" />
              <v-icon v-else small class="line-avatar-placeholder">person</v-icon>
              <span class="stato line-presence" :class="presenceClass"></span>
            </div>

            <div class="line-info">
              <div class="line-title">
                <div class="line-name">{{ squadra_.name }}</div>
                <div
                  v-if="staScegliendo_ || haScelto_"
                  class="line-status cyan darken-2 white--text"
                >
                  <span v-if="staScegliendo_">Sta scegliendo</span>
                  <span v-else>Ha scelto</span>
                </div>
                <div v-if="lineInactiveReason" class="line-inactive-reason">
                  {{ lineInactiveReason }}
                </div>
              </div>
              <div
                v-if="showLineCrediti || showLineMaxOfferta"
                class="line-meta"
              >
                <div class="crediti-wrapper">
                  <crediti
                    v-if="showLineCrediti"
                    :crediti="crediti"
                  ></crediti>
                  <div v-if="showLineMaxOfferta" class="offerta-max">
                    <div class="label">Max</div>
                    <animate-number :number="maxOfferta"></animate-number>
                  </div>
                </div>
              </div>
            </div>

            <div class="line-actions">
              <div v-if="isSpeaker_" class="line-countdown">
                {{ timeLeft != null ? timeLeft : 0 }}
              </div>
              <crediti
                v-if="isVincente && mostraVincente"
                :crediti="offerta"
                class="line-offerta offerta-vincente"
                variant="dark"
                glow
              ></crediti>
            </div>

            <div v-if="showLineMaxOffertaBar" class="line-bars">
              <div
                class="line-bar line-bar-max-offerta"
                title="Offerta massima"
              >
                <span :style="{ width: `${lineMaxOffertaRatio}%` }"></span>
              </div>
            </div>
          </div>

          <div v-else class="content">
            <div class="left-part">
              <img :src="pic" v-if="pic" />
              <div v-if="isSpeaker_" class="countdown">
                <div>{{ timeLeft != null ? timeLeft : 0 }}</div>
              </div>
            </div>

            <div class="details">
              <div class="nome">{{ squadra_.name }}</div>

              <ruoli-completati :id_squadra="id"></ruoli-completati>

              <div class="crediti-wrapper">
                <crediti
                  :crediti="crediti"
                ></crediti>

                <div class="offerta-max">
                  <div class="label">Max</div>
                  <animate-number :number="maxOfferta"></animate-number>
                </div>
              </div>
            </div>
            <div class="stato" :class="presenceClass"></div>
          </div>
        </div>
      </template>
      <v-list dense>
        <v-list-item v-if="showMostraRosa" @click="mostraRosa">
          <v-list-item-title
            ><v-icon small left class="text--text">admin_panel_settings</v-icon
            >Mostra rosa</v-list-item-title
          >
        </v-list-item>
        <v-list-item :disabled="forzaPassoDisabled" @click="forzaPasso">
          <v-list-item-title class="error--text"
            ><v-icon small left class="error--text">airline_stops</v-icon>Forza
            'Passo'</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          :disabled="setActiveDisabled"
          v-if="squadra_.active == 1"
          @click="setActive(0)"
        >
          <v-list-item-title class="error--text"
            ><v-icon small left class="error--text">person_remove</v-icon
            >Escludi temporaneamente</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          :disabled="setActiveDisabled"
          v-if="squadra_.active == 0"
          @click="setActive(1)"
        >
          <v-list-item-title
            ><v-icon small left>person_add</v-icon>Riammetti
            all'asta</v-list-item-title
          >
        </v-list-item>

        <v-list-item
          v-if="Config.STANDALONE"
          @click="promptEditCreditiSquadra(id)"
        >
          <v-list-item-title
            ><v-icon small left class="text--text">mode_edit</v-icon>Modifica
            crediti</v-list-item-title
          >
        </v-list-item>

        <v-list-item @click="showAstaOrder">
          <v-list-item-title
            ><v-icon left small class="text--text"
              >settings_backup_restore</v-icon
            >
            Ordine partecipanti</v-list-item-title
          >
        </v-list-item>

        <v-list-item @click="promptChangeAdmin">
          <v-list-item-title
            ><v-icon left small class="text--text">engineering</v-icon>
              <span v-if="adminUid == squadra_.id"
                >Rimuovi da Amministratore</span
              >
              <span v-else>Rendi Amministratore</span>
              <small class="d-inline-block error white--text ml-1 px-1 rounded">NEW</small>
          </v-list-item-title>
        </v-list-item>

           <v-list-item
          v-if="Config.STANDALONE"
          :disabled="!!eliminaSquadraReason"
          :title="eliminaSquadraReason"
          @click="showEliminaSquadra"
        >
          <v-list-item-content>
            <v-list-item-title class="error--text">
              <v-icon left small color="error">delete_forever</v-icon>
              Elimina squadra definitivamente
            </v-list-item-title>
            <v-list-item-subtitle v-if="eliminaSquadraReason" class="text-wrap">
              {{ eliminaSquadraReason }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <template v-if="showLayoutMenu">
          <v-divider class="mb-2"></v-divider>

          <v-list-item>
            <v-list-item-title>Layout</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-btn-toggle
              dense
              class="ml-2"
              v-model="tavoloLayoutModel"
              mandatory
              borderless
            >
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.TAVOLO_LAYOUT.CERCHIO"
                @click.stop
              >
                <v-icon :class="colorSpeedDial" small>lens</v-icon>
              </v-btn>
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.TAVOLO_LAYOUT.GRIGLIA"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">view_module</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-list-item-title></v-list-item-title>
          </v-list-item>

          <v-list-item
            v-show="tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO"
          >
            <v-btn-toggle
              dense
              class="progressive-sizes ml-2"
              v-model="tavoloSizeModel"
              mandatory
              borderless
            >
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.TAVOLO_SIZE.SMALL"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">lens</v-icon>
              </v-btn>
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.TAVOLO_SIZE.MEDIUM"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">lens</v-icon>
              </v-btn>
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.TAVOLO_SIZE.LARGE"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">lens</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-list-item-title></v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-btn-toggle
              dense
              class="progressive-sizes ml-2"
              v-model="squadreSizeModel"
              mandatory
              borderless
            >
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.SQUADRE_SIZE.SMALL"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">account_box</v-icon>
              </v-btn>
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.SQUADRE_SIZE.MEDIUM"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">account_box</v-icon>
              </v-btn>
              <v-btn
                :class="bgSpeedDial"
                :value="Constants.SQUADRE_SIZE.LARGE"
                @click.stop
              >
                <v-icon :class="colorSpeedDial">account_box</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-list-item-title></v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";
import Vuex from "vuex";
import AnimateNumber from "./AnimateNumber.vue";
import RuoliCompletati from "./RuoliCompletati";
import Crediti from "./Crediti";
import toast from "../../js/toast";
import * as Helpers from "../../js/helpers";

export default {
  name: "squadra-tavolo",
  mixins: [mixins, toast],
  components: { AnimateNumber, RuoliCompletati, Crediti },
  props: {
    id: {
      type: String,
      required: true,
      default: null,
    },
    showArrow: {
      type: Boolean,
    },
    size: {
      type: String,
      default: Constants.SQUADRE_SIZE.SMALL,
      validator(value) {
        return Object.values(Constants.SQUADRE_SIZE).indexOf(value) !== -1;
      },
    },
    disableMenu: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "card",
      validator(value) {
        return ["card", "line"].indexOf(value) !== -1;
      },
    },
    menuContext: {
      type: String,
      default: Constants.SQUADRA_TAVOLO_MENU_CONTEXT.TAVOLO,
      validator(value) {
        return (
          Object.values(Constants.SQUADRA_TAVOLO_MENU_CONTEXT).indexOf(value) !== -1
        );
      },
    },
    showLineCrediti: {
      type: Boolean,
      default: true,
    },
    showLineMaxOfferta: {
      type: Boolean,
      default: true,
    },
    showLineMaxOffertaBar: {
      type: Boolean,
      default: false,
    },
    lineMaxOffertaRatio: {
      type: Number,
      default: 0,
    },
    // clicked: {
    //   type: Function,
    //   default: function () {},
    // },
  },
  methods: {
    showAstaOrder() {
      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      db.emit("showAstaOrder");
    },
    showEliminaSquadra() {
      if (!this.eliminaSquadraReason) db.emit("showDialogEliminaSquadra", this.id);
    },
    promptChangeAdmin() {
      db.emit("promptChangeAdmin");
    },
    mostraRosa() {
      this.$store.dispatch("setSquadraSelected", this.id);
      if (this.is_mobile) {
        db.emit("showDialogAstaRosa");
      } else {
        db.emit("showDialogRoseLega");
      }
    },
    forzaPasso() {
      if (this.forzaPassoDisabled) {
        return;
      }
      Swal.fire({
        html:
          'Vuoi forzare un passo per <span class="bold">' +
          this.squadra_.name +
          "</span>?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.astaLogPassoForzato(this.id) // devo farlo prima per essere sicuro avvenga prima dell'assegnazione
            .then(db.setPasso(this.id, this.mode_poker))
            .catch((err) => {
              console.error(err);
              this.errorToast("Errore", "Operazione non consentita!");
            });
        }
      });
    },
    setActive(active) {
      if (this.setActiveDisabled) {
        return;
      }

      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }

      // STO DISATTIVANDO ADMIN
      // if (this.adminUid == this.id && active == 0) {
      //   Swal.fire({
      //     title: "Attenzione",
      //     text: "Sei l'amministratore di lega, dovrai comunque rimanere online per consentire agli altri partecipanti di proseguire l'asta. Vuoi continuare?",
      //     icon: "warning",
      //     showCancelButton: true,
      //     confirmButtonText: "Si",
      //     cancelButtonText: "No",
      //   }).then((result) => {
      //     if (result.isConfirmed == true) {
      //       db.setActiveSquadra(this.id, active).then(() => {
      //         db.setAstaMsg(
      //           Constants.ASTA_MSG.ANNULLA,
      //           "L'amministratore di lega si è escluso dall'asta. IMPORTANTE: Dovrà comunque rimanere online per consentire agli altri partecipanti di proseguire l'asta"
      //         );
      //       });
      //     }
      //   });
      //   return;
      // }

      db.setActiveSquadra(this.id, active).then(() => {
        if (active == 1) {
          this.astaLogRiammissioneAsta(this.id);
        } else {
          if (this.adminUid == this.id) {
            this.astaLogEsclusioneAstaAdmin(this.id);
            db.emit("swalAdminEscluso", false);
          } else {
            this.astaLogEsclusioneAsta(this.id);
          }
        }
      });
    },
  },
  computed: {
    eliminaSquadraReason() {
      return Helpers.eliminaSquadraDisabledReason(
        this.Config.STANDALONE, this.user_uid, this.asta_info,
        this.asta_round, this.id, this.squadra_
      );
    },
    timeLeft() {
      return this.asta_round.speakerTimeLeft;
    },
    isMenuContextPanoramica() {
      return (
        this.menuContext == Constants.SQUADRA_TAVOLO_MENU_CONTEXT.PANORAMICA
      );
    },
    showMostraRosa() {
      return !this.isMenuContextPanoramica;
    },
    showLayoutMenu() {
      return !this.isMenuContextPanoramica;
    },
    isCardVariant() {
      return this.variant == "card";
    },
    isLineVariant() {
      return this.variant == "line";
    },
    squadra_() {
      return this.asta_squadre[this.id];
    },
    maxOfferta() {
      return this.squadra_.max_offerta;
    },
    lineInactiveReason() {
      if (!this.isLineVariant || !this.squadra_) {
        return null;
      }

      if (!this.squadra_.active) {
        return "Squadra esclusa dall'asta";
      }

      if (
        this.calciatoreInAsta === null ||
        this.calciatoreInAsta === undefined ||
        !this.asta_info ||
        !this.asta_info.lega ||
        this.offerta != Constants.OFFERTA.PASSO ||
        (!this.mode_poker && !this.mode_selvaggia)
      ) {
        return null;
      }

      const calciatore = this.calciatore(this.calciatoreInAsta);
      const rilancioMinimo = this.mode_selvaggia
        ? Constants.RILANCIO_MIN
        : Constants.OFFERTA.MINIMA;
      const creditiMin =
        this.migliore_offerta && this.migliore_offerta.vincitore != null
          ? this.migliore_offerta.offerta + rilancioMinimo
          : this.Helpers.minOfferta(this.asta_settings.base_asta, calciatore);

      const joinRound = this.Helpers.canJoinRoundWithReason(
        this.asta_info.lega,
        this.squadra_,
        calciatore,
        creditiMin
      );

      return joinRound.reason || "Ha passato";
    },
    forzaPassoDisabled() {
      return (
        !this.admin ||
        !this.calciatoreInAsta ||
        this.not_running ||
        this.mode_assegna ||
        this.squadra_.active === 0 ||
        (this.mode_poker && this.asta_round.speaker !== this.id) ||
        this.offerta == Constants.OFFERTA.PASSO ||
        this.adminUid == this.id
      );
    },
    setActiveDisabled() {
      return !this.admin;
    },
    presence() {
      return this.asta_online[this.id];
    },
    presenceClass() {
      return this.getPresenceClass(this.presence);
      // return {
      //   online: this.presence == Constants.PRESENCE_STATES.ONLINE,
      //   idle:
      //     this.presence == Constants.PRESENCE_STATES.IDLE ||
      //     this.presence == Constants.PRESENCE_STATES.AWAY ||
      //     this.presence == Constants.PRESENCE_STATES.PENDING,
      //   offline:
      //     this.presence == Constants.PRESENCE_STATES.RESET ||
      //     this.presence == Constants.PRESENCE_STATES.OFFLINE ||
      //     this.presence == "" ||
      //     this.presence == null,
      // };
    },
    squadraClass: function () {
      return {
        showArrow: this.showArrow,
        [this.squadraSizeClass]: this.isCardVariant,
        [`variant-${this.variant}`]: true,
        isMine: this.id == this.user_uid,
        vincente: this.isVincente,
        isSpeaker: this.isSpeaker_,
        disableMenu: this.disableMenu,
        haPassato:
          (((this.mode_poker || this.mode_selvaggia) &&
            this.offerta == Constants.OFFERTA.PASSO) ||
            !this.squadra_.active),
      };
    },
    squadraSizeClass() {
      return this.size;
    },
    staScegliendo_() {
      return this.staScegliendo(this.id);
    },
    haScelto_() {
      return this.haScelto(this.id);
    },
    isSpeaker_() {
      return this.isSpeaker(this.id);
    },
    isVincente() {
      return (
        this.offerta &&
        this.offerta > 0 &&
        this.migliore_offerta.vincitore == this.id
      );
    },
    mostraVincente() {
      return this.mode_poker || this.mode_selvaggia;
    },
    offerta: function () {
      return this.asta_round.offerte ? this.asta_round.offerte[this.id] : -1;
    },
    crediti: function () {
      return this.squadra_.crediti;
    },
    pic: function () {
      return this.squadra_.pic ? this.squadra_.pic : null;
    },
    migliore_offerta_val: function () {
      return this.migliore_offerta.offerta
        ? this.migliore_offerta.offerta
        : null;
    },
    squadreSizeModel: {
      get() {
        return this.squadreSize;
      },
      set(value) {
        this.$store.dispatch("setSquadreSize", value);
      },
    },
    tavoloSizeModel: {
      get() {
        return this.tavoloSize;
      },
      set(value) {
        this.$store.dispatch("setTavoloSize", value);
      },
    },
    tavoloLayoutModel: {
      get() {
        return this.tavoloLayout;
      },
      set(value) {
        // check
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          let nSquadre = _.size(this.asta_squadre);
          let limit = Constants.LIMIT_SQUADRE_LAYOUT_CERCHIO;
          if (nSquadre > limit) {
            Swal.fire({
              icon: "info",
              title: "Suggerimento",
              text:
                "In leghe con più di " +
                limit +
                ' squadre è preferibile la visualizzazione a "griglia" e non a "tavolo rotondo" per evitare sovrapposizioni tra le squadre intorno al tavolo',
              confirmButtonText: "Ok, ho capito",
            });
          }
        }
        this.$store.dispatch("setTavoloLayout", value);
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          this.$store.dispatch("setSquadreSize", Constants.SQUADRE_SIZE.SMALL);
        }
      },
    },
    bgSpeedDial() {
      return "white";
    },
    colorSpeedDial() {
      return "text--text";
    },
    ...Vuex.mapGetters([
      "asta_squadre",
      "asta_info",
      "asta_round",
      "asta_online",
      "migliore_offerta",
      "tavoloLayout",
      "useSound",
      "is_mobile",
      "user_uid",
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
// .speeddial {
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
.v-btn-toggle {
  margin: 0 0px 6px 0;
  flex-direction: row-reverse;
  background: transparent;

  > .v-btn.v-btn:first-child {
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  > .v-btn.v-btn:last-child {
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .v-btn {
    margin: 0;
    opacity: 1;
    background: var(--v-navy-base);
    &.v-item--active {
      color: transparent;
      // background: var(--v-navy-base) !important;
      box-shadow: 0px 5px 0px -3px var(--v-navy-base);
      i {
        // color: white !important;
      }
    }
  }
  &.progressive-sizes {
    .v-btn {
      &:first-child i {
        font-size: 12px;
      }

      i {
        font-size: 20px;
      }

      &:last-child i {
        font-size: 28px;
      }
    }
  }
}
// }
.squadra-tavolo {
  // box-shadow: 0 13px 6px -10px rgb(0 0 0 / 49%);
  background: transparent;
  position: relative;
  .haScelto,
  .staScegliendo {
    position: absolute;
    z-index: 2;
    border-radius: 100px;
    padding: 0px 5px;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .staScegliendo {
    min-width: 70px;
  }
  .haScelto {
    min-width: 50px;
  }
  &.showArrow:after {
    content: "";
    position: absolute;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-color: transparent var(--v-navy-base);
    display: block;
    width: 0;
    z-index: 1;
    margin-top: -5px;
    right: -5px;
    top: 50%;
  }
  &.isSpeaker .content {
    animation: pulse 1.25s infinite;
  }

  &.haPassato {
    background: var(--v-navy-darken3);
    box-shadow: none;
    border-radius: 10px;

    .content {
      opacity: 0.3;
      // background-color: white;
      // color: var(--v-navy-base);
    }

    &.variant-line {
      background: transparent;
      box-shadow: none;
      border-radius: 0;
    }

    .content-line {
      opacity: 0.42;
    }

    .line-actions,
    .crediti-wrapper {
      filter: grayscale(1);
    }
  }
  &.vincente {
    z-index: 2 !important;
    .offerta-vincente {
      animation: vanishIn 0.5s;
    }
  }

  .content {
    display: flex;
    color: white;
    border-radius: 10px;
    cursor: pointer;
    background-color: var(--dark_card_bk);
    position: relative;
    overflow: hidden;
    transition: box-shadow 0.15s ease, transform 0.15s ease;
    .stato {
      position: absolute;
      top: 4px;
      right: 4px;
    }

    &:before {
      content: "...";
      position: absolute;
      right: 6px;
      bottom: 3px;
      z-index: 2;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 1;
      opacity: 0;
      transition: opacity 0.15s ease;
    }
  }

  .content-line {
    align-items: end;
    color: white;
    cursor: pointer;
    display: grid;
    grid-template-columns: 26px minmax(0, 1fr) auto;
    column-gap: 6px;
    row-gap: 3px;
    min-height: 38px;
    padding: 5px;
    position: relative;
    transition: background-color 0.16s ease;
    width: 100%;
    border-radius: 6px;
  }

  .line-avatar {
    align-items: center;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    display: flex;
    flex: 0 0 26px;
    height: 26px;
    justify-content: center;
    overflow: visible;
    position: relative;
    width: 26px;

    img {
      border-radius: 50%;
      display: block;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  .line-avatar-placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  .line-presence {
    outline: 2px solid var(--dark_card_bk);
    height: 8px;
    left: -1px;
    position: absolute;
    top: -1px;
    width: 8px;
  }

  .line-info {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
  }

  .line-title {
    align-items: center;
    display: flex;
    gap: 4px;
    min-width: 0;
  }

  .line-name {
    flex: 0 1 auto;
    font-size: 11px;
    font-weight: 700;
    min-width: 0;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .line-status {
    border-radius: 100px;
    flex: 0 0 auto;
    font-size: 8px;
    font-weight: 700;
    line-height: 1;
    max-width: 100%;
    overflow: hidden;
    padding: 2px 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .line-inactive-reason {
    color: rgba(255, 255, 255, 0.52);
    flex: 1 1 auto;
    font-size: 8px;
    font-weight: 700;
    line-height: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .line-meta {
    align-items: center;
    display: flex;
    gap: 4px;
    min-width: 0;
    overflow: hidden;
    // padding: 5px 0;

    .crediti-wrapper {
      padding: 0;
    }
  }

  .line-bars {
    grid-column: 2 / -1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    width: 100%;
  }

  .line-bar {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 999px;
    height: 3px;
    overflow: hidden;
    width: 100%;

    span {
      border-radius: inherit;
      display: block;
      height: 100%;
      transition: width 0.22s ease;
    }
  }

  .line-bar-max-offerta span {
    background: rgba(255, 255, 255, 0.82);
  }

  .line-actions {
    align-items: center;
    display: flex;
    flex: 0 0 auto;
    gap: 3px;
  }

  .line-offerta {
    font-size: 9px;
    padding: 1px 6px;
    box-shadow: 0px 0px 4px 1px rgba(246, 189, 0, 0.8);
  }

  .line-countdown {
    align-items: center;
    background: transparent;
    border: 1px solid var(--v-primary-base);
    border-radius: 4px;
    color: var(--v-primary-base);
    display: inline-flex;
    font-size: 9px;
    font-weight: 700;
    justify-content: center;
    min-width: 20px;
    padding: 1px 4px;
  }

  &:not(.disableMenu):hover .content {
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.22),
      0 6px 14px rgba(0, 0, 0, 0.22);
    transform: translateY(-1px);

    &:before {
      opacity: 1;
    }
  }

  &:not(.disableMenu):hover .content-line {
    background: rgba(255, 255, 255, 0.06);
  }

  &.variant-line.isMine .content-line {
    background: color-mix(in srgb, var(--v-accent-base), transparent 88%);
    box-shadow: inset 0 0 0 1px
      color-mix(in srgb, var(--v-accent-base), transparent 58%);
  }

  &.variant-line.isMine:not(.disableMenu):hover .content-line {
    background: color-mix(in srgb, var(--v-accent-base), transparent 82%);
  }

  &.small {
    margin: 2px;
    .content {
      height: 50px;
      width: 110px;
    }
    .nome {
      font-size: 8px;
      max-width: 60px;
    }
    .Ruolo {
      width: 13px;
      height: 13px;
      min-width: 13px;
    }
    .crediti-wrapper {
      font-size: 9px;
    }
    .haScelto,
    .staScegliendo {
      font-size: 9px;
      top: -4px;
    }
    .left-part {
      width: 30px;
      img {
        width: 53px;
        left: -11px;
      }
    }
    .ruoli-completati{
      height: 16px;
    }
  }
  &.medium {
    margin: 4px;
    .content {
      height: 60px;
      width: 120px;
    }
    .nome {
      font-size: 9px;
      max-width: 80px;
      padding-top: 5px;
    }
    .Ruolo {
      width: 13px;
      height: 13px;
      min-width: 13px;
    }
    .crediti-wrapper {
      font-size: 11px;
    }
    .haScelto,
    .staScegliendo {
      font-size: 9px;
      top: -3px;
    }
    .left-part {
      width: 40px;
      img {
        width: 62px;
        left: -11px;
      }
    }
  }
  &.large {
    margin: 5px;
    .content {
      height: 70px;
      width: 140px;
    }
    .nome {
      font-size: 12px;
      max-width: 85px;
      padding-top: 7px;
    }
    .Ruolo {
      width: 13px;
      height: 13px;
      min-width: 13px;
    }
    .crediti-wrapper {
      font-size: 12px;
    }
    .haScelto,
    .staScegliendo {
      font-size: 11px;
      top: -3px;
      min-width: 80px;
    }
    .left-part {
      width: 55px;
      img {
        width: 70px;
        left: -7px;
      }
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1; // prende tutto il rimanente della width
  }

  .nome {
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    word-wrap: break-word;
    padding: 0px 11px 0 3px;
    text-align: center;
  }

  .left-part {
    position: relative;
    overflow: hidden;
    border-radius: 3px 0 0 3px;
    img {
      position: absolute;
      top: 0;
    }
    .countdown {
      position: absolute;
      width: 100%;
      bottom: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        background: rgb(48 63 70);
        border-radius: 4px;
        padding: 0 2px;
        font-size: 9px;
        min-width: 20px;
        text-align: center;
      }
    }
  }
  .crediti-wrapper {
    // background: rgb(0 0 0 / 30%);
    display: flex;
    align-items: center;
    padding: 4px 2px;
    font-size: 9px;
    gap: 5px;
    justify-content: center;
    .crediti, .offerta-max {
      font-size: 9px;
      padding: 1px 5px;
    }
  }

  .offerta-max {
    align-items: center;
    background: #ffffff21;
    border-radius: 4px;
    color: white;
    display: inline-flex;
    font-weight: bold;
    gap: 3px;
    justify-content: center;
    white-space: nowrap;
  }

  .offerta {
    position: absolute;
    left: -10px;
    top: -10px;
    z-index: 2;
  }
}

.menu-squadra {
  position: absolute;
  right: 0px;
  bottom: -18px;
}

.menu-squadra-btn {
  margin: 0 !important;
  width: 15px !important;
}
</style>
